import { Routes, Route, BrowserRouter } from 'react-router-dom';

// Import Theme Provider
import { ThemeProvider } from './contexts/ThemeContext';

// Import Layout
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';

// Import Theme Styles
import './styles/theme.css';

// Import components
import CTA from './components/CTA';
import Features from './components/Features';
import Features2 from './components/Features2';
import FeaturesRevolution from './components/FeaturesRevolution';
import FeaturesMinimal from './components/FeaturesMinimal';
import FeaturesElegant from './components/FeaturesElegant';
import FeaturesRevamp from './components/FeaturesRevamp';
import FeaturesPremium from './components/FeaturesPremium';
import Footer from './components/Footer';
import FooterPremium from './components/FooterPremium';
import HeaderPremium from './components/HeaderPremium';
import Hero2 from './components/Hero2';
import HeroRevolution from './components/HeroRevolution';
import PlatformFeatures from './components/PlatformFeatures';
import PlatformFeatures2 from './components/PlatformFeatures2';
import PlatformFeaturesPremium from './components/PlatformFeaturesPremium';
import PlatformFeaturesModern from './components/PlatformFeaturesModern';
import Testimonials from './components/Testimonials';
import Home from './pages/Home';
import ModernHome from './pages/ModernHome';
import ProductPage from './pages/ProductPage';
import PricingPage from './pages/PricingPage';
import ContactPage from './pages/ContactPage';
import FeaturesPage from './pages/FeaturesPage';
import SolutionsPage from './pages/SolutionsPage';
import DemoPage from './pages/DemoPage';
import ContentManagementPage from './pages/ContentManagementPage';
import PageDesignPage from './pages/PageDesignPage';
import UserManagementPage from './pages/UserManagementPage';
import SubscriptionPage from './pages/SubscriptionPage';
import ThemeDesignPage from './pages/ThemeDesignPage';
import TechnicalFeaturesPage from './pages/TechnicalFeaturesPage';
import WidgetGallery from './pages/WidgetGallery';
import ThemeDesignSystemPage from './pages/ThemeDesignSystemPage';
import ThemeDemoPage from './pages/ThemeDemoPage';



function App() {
  return (
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/demo" element={<DemoPage />} />
          <Route path="/products" element={<ProductPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/content-management" element={<ContentManagementPage />} />
          <Route path="/page-design" element={<PageDesignPage />} />
          <Route path="/widget-gallery" element={<WidgetGallery />} />
          <Route path="/user-management" element={<UserManagementPage />} />
          <Route path="/subscription" element={<SubscriptionPage />} />
          <Route path="/theme-design" element={<ThemeDesignPage />} />
          <Route path="/theme-design-system" element={<ThemeDesignSystemPage />} />
          <Route path="/technical-features" element={<TechnicalFeaturesPage />} />
          <Route path="/hero-revolution" element={<HeroRevolution />} />
          <Route path="/hero-2" element={<Hero2 />} />
          <Route path="/features-component" element={<Features />} />
          <Route path="/features-elegant" element={<FeaturesElegant />} />
          <Route path="/features-revamp" element={<FeaturesRevamp />} />
          <Route path="/features-revolution" element={<FeaturesRevolution />} />
          <Route path="/features-minimal" element={<FeaturesMinimal />} />
          <Route path="/features-premium" element={<FeaturesPremium />} />
          <Route path="/features-2" element={<Features2 />} />
          <Route path="/platform-features" element={<PlatformFeatures />} />
          <Route path="/platform-features-2" element={<PlatformFeatures2 />} />
          <Route path="/platform-features-premium" element={<PlatformFeaturesPremium />} />
          <Route path="/platform-features-modern" element={<PlatformFeaturesModern />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/cta" element={<CTA />} />
          <Route path="/footer" element={<Footer />} />
          <Route path="/header-premium" element={<HeaderPremium />} />
          <Route path="/footer-premium" element={<FooterPremium />} />
          <Route path="/theme-demo" element={<ThemeDemoPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
  );
}

export default App;